import React from "react";
import Nav from "../Components/Nav";
import ProductsComponent from "../Components/Products";
import Footer from "../Components/Footer";

export default function Products() {
  return (
    <div>
      <Nav />
      <ProductsComponent />
      <Footer />
    </div>
  );
}
